import { useToastContext } from "components/alert/ToastContext";
import { Label } from "components/input/Label";
import GrupoUsuarios from "model/administracao/cadastro/GrupoUsuarios";
import Usuario from "model/administracao/cadastro/Usuario";
import DocumentoAcao from "model/documentos/acesso/DocumentoAcao";
import DocumentoPastaAcesso from "model/documentos/acesso/DocumentoPastaAcesso";
import DocumentoPastaAcessoGrupo from "model/documentos/acesso/DocumentoPastaAcessoGrupo";
import DocumentoPastaAcessoUsuario from "model/documentos/acesso/DocumentoPastaAcessoUsuario";
import DocumentoPastaAcao from "model/documentos/acesso/DocumentoPastaAcao";
import { Button } from "primereact/button";
import { Checkbox } from "primereact/checkbox";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";
import { TabPanel, TabView } from "primereact/tabview";
import { useLoadingContext } from "provider/LoadingProvider";
import { useEffect, useState } from "react";
import DocumentoAcessoService from "service/documentos/DocumentoAcessoService";
import { DocumentoPasta } from "model/documentos/DocumentoPasta";
import { AutoComplete } from "primereact/autocomplete";
import { usuarioCompleteMethod, usuarioItemTemplate } from "utils/autocompleteUtils";

type Props = {
    visible: boolean;
    onHide: () => void;
    idPasta: number;
    onConfirm: () => void;
}

const documentoAcessoService = new DocumentoAcessoService();
export default function ModalDocumentoPastaAcesso(props: Props) {
    const [pastaAcesso, setPastaAcesso] = useState<DocumentoPastaAcesso>(new DocumentoPastaAcesso());
    const [acoes, setAcoes] = useState<DocumentoPastaAcao[]>([]);
    const [visibleGrupo, setVisibleGrupo] = useState<boolean>(false);
    const [grupoSelecionado, setGrupoSelecionado] = useState<GrupoUsuarios | null>(null);

    const [visibleUsuario, setVisibleUsuario] = useState<boolean>(false);
    const [usuarioSelecionado, setUsuarioSelecionado] = useState<Usuario | null>(null);

    const [grupos, setGrupos] = useState<GrupoUsuarios[]>([]);
    const [usuarios, setUsuarios] = useState<Usuario[]>([]);
    
    const [usuariosFiltrados, setUsuariosFiltrados] = useState<Usuario[]>([])

    const { startLoading, stopLoading } = useLoadingContext();
    const { msgErro, msgAlerta } = useToastContext();

    function handleConfirm() {
        startLoading();
        documentoAcessoService.salvarAcessoPasta(pastaAcesso).then(() => {
            stopLoading();
            props.onConfirm();
            props.onHide();
        }).catch((error) => {
            stopLoading();
            msgErro("Erro ao mover", error?.data?.message || "Erro ao mover pasta");
            console.error("Erro ao mover pasta:", error);
        });

    }

    useEffect(() => {
        documentoAcessoService.buscarAcessosPasta(props.idPasta).then((json) => {
            setPastaAcesso(json);
        }).catch((error) => {
            console.error("Erro ao buscar pastas:", error);
        });
        documentoAcessoService.buscarAcoesPasta().then((json) => {
            setAcoes(json);
        }).catch((error) => {
            console.error("Erro ao buscar ações:", error);
        });
        documentoAcessoService.usuarios().then((json) => {
            setUsuarios(json);
        }).catch((error) => {
            console.error("Erro ao buscar usuários:", error);
        });
        documentoAcessoService.grupos().then((json) => {
            setGrupos(json);
        }).catch((error) => {
            console.error("Erro ao buscar grupos:", error);
        });
    }, [])

    return (
        <Dialog
            header="Acesso à pasta"
            visible={props.visible}
            baseZIndex={100}
            style={{ width: '85%' }}
            onHide={props.onHide}
            footer={<>
                <Button label="Cancelar" icon="pi pi-times" className="p-button-danger" onClick={props.onHide} />
                <Button label="Gravar" icon="pi pi-check" onClick={handleConfirm} />
            </>}
        >
            <Dialog
                header={visibleGrupo ? "Adicionar Grupo" : "Adicionar Usuário"}
                footer={<Button label="Confirmar" onClick={() => {
                    if (visibleGrupo) {
                        if (pastaAcesso.grupos.findIndex((grupo) => grupo.grupo.id === grupoSelecionado?.id) > -1) {
                            msgAlerta("Grupo já adicionado", "O grupo selecionado já foi adicionado.");
                            return;
                        }
                        setPastaAcesso({ ...pastaAcesso, grupos: [...pastaAcesso.grupos, new DocumentoPastaAcessoGrupo(grupoSelecionado!, [])] });
                        setGrupoSelecionado(null);
                        setVisibleGrupo(false);
                    } else {
                        if (pastaAcesso.usuarios.findIndex((usuario) => usuario.usuario.id === usuarioSelecionado?.id) > -1) {
                            msgAlerta("Usuário já adicionado", "O usuário selecionado já foi adicionado.");
                            return;
                        }
                        setPastaAcesso({ ...pastaAcesso, usuarios: [...pastaAcesso.usuarios, new DocumentoPastaAcessoUsuario(usuarioSelecionado!, [])] });
                        setUsuarioSelecionado(null);
                        setVisibleUsuario(false);
                    }
                }} />}
                visible={visibleGrupo || visibleUsuario}
                onHide={() => {
                    setVisibleGrupo(false);
                    setVisibleUsuario(false);
                    setGrupoSelecionado(null);
                    setUsuarioSelecionado(null);
                }}
            >
                {visibleGrupo ? <Dropdown
                    value={visibleGrupo ? grupoSelecionado : usuarioSelecionado}
                    options={visibleGrupo ? grupos : usuarios}
                    optionLabel={"nome"}
                    placeholder={visibleGrupo ? "Selecione um grupo" : "Selecione um usuário"}
                    onChange={(e) => {
                        if (visibleGrupo) {
                            setGrupoSelecionado(e.value as GrupoUsuarios);
                        } else {
                            setUsuarioSelecionado(e.value as Usuario);
                        }
                    }}
                /> : <AutoComplete
                    dropdown
                    value={usuarioSelecionado}
                    placeholder="Selecione um Usuário"
                    field="nome"
                    itemTemplate={(item: Usuario) => usuarioItemTemplate(item)}
                    suggestions={usuariosFiltrados}
                    completeMethod={(e) => {
                        let filtered: Usuario[] = usuarioCompleteMethod(usuarios, e.query);
                        setUsuariosFiltrados(filtered);
                    }}
                    onChange={(e) => {
                        setUsuarioSelecionado(e.value);
                    }}
                />}

            </Dialog>
            <div style={{ marginBottom: 16 }}>
                <Checkbox
                    checked={pastaAcesso.pasta?.acessoAplicaSubpastas as boolean}
                    onChange={(e) => {
                        setPastaAcesso({ ...pastaAcesso, pasta: { ...pastaAcesso.pasta, acessoAplicaSubpastas: e.checked as boolean } as DocumentoPasta });
                    }}
                    style={{ marginRight: 8 }}
                />
                <Label>Aplicar acesso às subpastas</Label>
            </div>
            <TabView >
                <TabPanel header="Grupos">
                    <DataTable value={pastaAcesso.grupos} header={<>
                        <Button
                            label="Adicionar grupo"
                            icon="pi pi-plus"
                            onClick={() => {
                                setVisibleGrupo(true);
                            }}
                        />
                    </>} scrollable scrollHeight="flex" emptyMessage="Nenhum grupo cadastrado">
                        <Column field="grupo.nome" header="Grupo" style={{ width: "30%" }} frozen />
                        <Column header="Marcar todas" body={rowData => {
                            return (
                                <Checkbox
                                    checked={rowData.acoes.length === acoes.length}
                                    onChange={(e) => {
                                        if (e.checked) {
                                            rowData.acoes = [...acoes];
                                        } else {
                                            rowData.acoes = [];
                                        }
                                        setPastaAcesso({ ...pastaAcesso });
                                    }}
                                />
                            );
                        }} />
                        {acoes.map((acao) => {
                            return (
                                <Column key={acao.id} header={acao.nome} bodyStyle={{ textAlign: "center" }} body={(rowData: DocumentoPastaAcessoGrupo) => {
                                    return (
                                        <Checkbox

                                            checked={rowData.acoes.findIndex((acaoGrupo) => acaoGrupo.id == acao.id) > -1}
                                            onChange={(e) => {
                                                if (e.checked) {
                                                    rowData.acoes.push(acao);
                                                } else {
                                                    rowData.acoes = rowData.acoes.filter((acaoGrupo) => acaoGrupo.id !== acao.id);
                                                }
                                                setPastaAcesso({ ...pastaAcesso })
                                            }}
                                        />
                                    );
                                }} />
                            );
                        })}
                        <Column header="" body={(rowData: DocumentoPastaAcessoGrupo) => <Button
                            icon="pi pi-trash"
                            className="p-button-danger"
                            onClick={() => {
                                pastaAcesso.grupos = pastaAcesso.grupos.filter((grupo) => grupo.grupo.id !== rowData.grupo.id);
                                setPastaAcesso({ ...pastaAcesso });
                            }}
                        />} >
                        </Column>
                    </DataTable>
                </TabPanel>
                <TabPanel header="Usuários">
                    <DataTable value={pastaAcesso.usuarios} header={<>
                        <Button
                            label="Adicionar usuário"
                            icon="pi pi-plus"
                            onClick={() => {
                                setVisibleUsuario(true);
                            }}
                        />
                    </>} scrollable scrollHeight="flex" emptyMessage="Nenhum usuário cadastrado">
                        <Column field="usuario.nome" header="Usuário" style={{ width: "30%" }} frozen />
                        <Column header="Marcar todas" body={rowData => {
                            return (
                                <Checkbox
                                    checked={rowData.acoes.length === acoes.length}
                                    onChange={(e) => {
                                        if (e.checked) {
                                            rowData.acoes = [...acoes];
                                        } else {
                                            rowData.acoes = [];
                                        }
                                        setPastaAcesso({ ...pastaAcesso });
                                    }}
                                />
                            );
                        }} />
                        {acoes.map((acao) => {
                            return (
                                <Column key={acao.id} header={acao.nome} style={{ textAlign: "center" }} body={(rowData: DocumentoPastaAcessoGrupo) => {
                                    return (
                                        <Checkbox
                                            checked={rowData.acoes.findIndex((acaoUsuario) => acaoUsuario.id == acao.id) > -1}
                                            onChange={(e) => {
                                                if (e.checked) {
                                                    rowData.acoes.push(acao);
                                                } else {
                                                    rowData.acoes = rowData.acoes.filter((acaoUsuario) => acaoUsuario.id !== acao.id);
                                                }
                                                setPastaAcesso({ ...pastaAcesso })
                                            }}
                                        />
                                    );
                                }} />
                            );
                        })}
                        <Column header="" body={(rowData: DocumentoPastaAcessoUsuario) => <Button
                            icon="pi pi-trash"
                            className="p-button-danger"
                            onClick={() => {
                                pastaAcesso.usuarios = pastaAcesso.usuarios.filter((usuario) => usuario.usuario.id !== rowData.usuario.id);
                                setPastaAcesso({ ...pastaAcesso });
                            }}
                        />} ></Column>
                    </DataTable>
                </TabPanel>
            </TabView>

        </Dialog >
    );
}